import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import HeroSection from "./HeroSection";
import OnlyProcessWorkSection from "./OnlyProcessWorkSection";
import FinalCTA from "../HomePage/FinalCTA";
import ProcessDifference from "./ProcessDifference";
import ProcessDetailPage from "./Processdetailpage ";

const FullProcessPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Our Process | Ashlar Building Group</title>
        <meta
          name="description"
          content="Discover how Ashlar Building Group manages complex construction projects from start to finish — with structured systems, clear communication, and third-generation craftsmanship."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://yourdomain.com/process" />
        <meta property="og:title" content="Our Process | Ashlar Building Group" />
        <meta
          property="og:description"
          content="From planning to completion — see how Ashlar delivers high-value projects with integrity, structure, and zero shortcuts."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://yourdomain.com/process" />
      </Helmet>

      <HeroSection />
      <OnlyProcessWorkSection />
      <ProcessDetailPage />
      <ProcessDifference />
      <FinalCTA />
    </>
  );
};

export default FullProcessPage;
